import {ValueObject} from '@s-ui/domain'

export class LeadHitUserRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.endpointUrl
   **/
}
